const Testimonial = () => null;

export default Testimonial;
